import { render } from "./LEDSelector.vue?vue&type=template&id=77c35651&scoped=true&ts=true"
import script from "./LEDSelector.vue?vue&type=script&lang=ts"
export * from "./LEDSelector.vue?vue&type=script&lang=ts"

import "./LEDSelector.vue?vue&type=style&index=0&id=77c35651&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-77c35651"]])

export default __exports__